<template>
  <transition name="modal-fade">
    <div v-if="visible" class="modal-overlay">
      <div class="modal-box">
        <div class="modal-message">{{ message }}</div>
        <div class="modal-buttons">
          <button class="btn-confirm" @click="handleConfirm">确定</button>
          <button v-if="showCancel" class="btn-cancel" @click="handleCancel">取消</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ToastComponent',
  data() {
    return {
      visible: false,
      message: '',
      showCancel: false,
      onConfirm: null,
      onCancel: null
    }
  },
  methods: {
    show(options) {
      if (typeof options === 'string') {
        this.message = options
        this.showCancel = false
        this.onConfirm = null
        this.onCancel = null
      } else {
        this.message = options.message || ''
        this.showCancel = options.showCancel || false
        this.onConfirm = options.onConfirm || null
        this.onCancel = options.onCancel || null
      }
      this.visible = true
    },
    handleConfirm() {
      this.visible = false
      if (this.onConfirm) {
        this.onConfirm()
      }
    },
    handleCancel() {
      this.visible = false
      if (this.onCancel) {
        this.onCancel()
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-box {
  background: #fff;
  border-radius: 12px;
  padding: 30px 40px;
  min-width: 320px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.modal-message {
  font-size: 16px;
  color: #333;
  margin-bottom: 25px;
  line-height: 1.5;
}
.modal-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
}
.btn-confirm {
  flex: 1;
  height: 44px;
  background: #3d8c40;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s;
}
.btn-confirm:hover {
  background: #2e7d32;
}
.btn-cancel {
  flex: 1;
  height: 44px;
  background: #fff;
  border: 1px solid #3d8c40;
  border-radius: 6px;
  color: #3d8c40;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s;
}
.btn-cancel:hover {
  background: #f5f5f5;
}
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.3s;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}
</style>
